var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"md":"6","offset-md":"3"}},[_c('v-card',{staticClass:"mt-4",attrs:{"elevation":"0","rounded":"lg"}},[_c('v-card-title',[_vm._v(" Список контроллеров ")]),_c('controllers-list')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }